/**
 * Construit un FormData multipart pour POST /request/events/store (Laravel).
 */
export default function buildEventStoreFormData({ ticketsData, eventData, affiche, image_lieu_evenement }) {
    const formData = new FormData();

    if (affiche instanceof File) {
        formData.append('affiche', affiche);
    }

    if (image_lieu_evenement instanceof File) {
        formData.append('image_lieu_evenement', image_lieu_evenement);
    }

    if (eventData?.type_evenement && typeof eventData.type_evenement === 'object') {
        Object.entries(eventData.type_evenement).forEach(([key, value]) => {
            formData.append(`eventData[type_evenement][${key}]`, value ? '1' : '0');
        });
    }

    Object.entries(eventData || {}).forEach(([key, value]) => {
        if (key === 'type_evenement') {
            return;
        }
        if (value !== null && value !== undefined && value !== '') {
            formData.append(`eventData[${key}]`, value);
        }
    });

    (ticketsData || []).forEach((ticket, index) => {
        Object.entries(ticket || {}).forEach(([key, value]) => {
            if (value === null || value === undefined) {
                return;
            }
            if (typeof value === 'function') {
                return;
            }
            formData.append(`ticketsData[${index}][${key}]`, value);
        });
    });

    return formData;
}
